import Testarossa from './Testarossa'

export default Testarossa
// eslint-disable-next-line import/export
export * from './Testarossa'
